import type {
  CheckoutInterval,
  CheckoutPlan,
} from '@klab-berlin/api-sdk/lib/types/requests/Billing';
import type { CheckoutErrorKind } from './checkout.types';

// Referral discount code applied via the trial-mode toggle.
export const REF_RABATT_CODE = 'ref-rabatt';

// Contract term is always 12 months, independent of billing interval.
export const TERM_MONTHS = 12;

export const VALID_PLANS: readonly CheckoutPlan[] = ['pro', 'meinFortbildung', 'muki', 'kombi'];
export const VALID_INTERVALS: readonly CheckoutInterval[] = ['monthly', 'yearly'];

export const EMAIL_MAX_LENGTH = 254;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const CHECK_EMAIL_DEBOUNCE_MS = 500;

export const PLAN_LABELS: Record<CheckoutPlan, string> = {
  pro: 'meinUnterricht Pro',
  meinFortbildung: 'meineFortbildung',
  muki: 'meinUnterricht KI',
  kombi: 'meinUnterricht 360',
};

export const ERROR_LABELS: Record<CheckoutErrorKind, string> = {
  InvalidPlan: 'The selected plan is not valid.',
  InvalidInterval: 'The selected billing interval is not valid.',
  InvalidPromoCode: 'The entered promo code is not valid.',
  CheckoutSessionFailed: 'The payment could not be initiated. Please try again later.',
  NetworkError: 'A network error occurred. Please check your connection and try again.',
};
